import React from 'react';
import {Hero} from "./routes/Hero";
import {createBrowserRouter, RouterProvider} from "react-router-dom";
import {ErrorPage} from "./routes/ErrorPage";
import {ImprintPage} from "./routes/ImprintPage";
import {PrivacyPolicyPage} from "./routes/PrivacyPolicyPage";

const router = createBrowserRouter([
    {
        path: "/",
        element: <Hero/>,
        errorElement: <ErrorPage/>
    },
    {
        path: "/imprint",
        element: <ImprintPage/>,
    },
    {
        path: "/privacypolicy",
        element: <PrivacyPolicyPage/>,
    },
]);

function App() {
    return (
        <RouterProvider router={router}/>
    );
}

export default App;


